// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/kanej/projects/sites/www.kanej.me/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("/Users/kanej/projects/sites/www.kanej.me/src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("/Users/kanej/projects/sites/www.kanej.me/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-talks-js": () => import("/Users/kanej/projects/sites/www.kanej.me/src/pages/talks.js" /* webpackChunkName: "component---src-pages-talks-js" */)
}

exports.data = () => import("/Users/kanej/projects/sites/www.kanej.me/.cache/data.json")

